import React, { useState } from "react";

// Renders a generated marketing illustration from public/images/, with a
// graceful escape hatch when the file isn't there.
//
// The artwork is produced out-of-band by `node scripts/gen-images.mjs` and
// committed as PNGs. It is deliberately NOT imported from src/assets: a bare
// `import` of a missing file is a hard webpack build failure, which would mean
// nobody can build the app until someone has run the generator and paid for the
// images. Referencing public/ by URL instead turns "not generated yet" into a
// runtime 404 that this component swallows — so the page renders correctly
// either way, and the art is purely additive.
//
// On a 404 (or a decode error) we render `fallback`, which is null for the
// decorative sub-page banners and the original <HeroMockup /> on the landing
// hero — so the hero never collapses to empty space.
const MarketingArt = ({ src, alt = "", className = "", fallback = null, eager = false }) => {
  const [failed, setFailed] = useState(false);

  if (failed) return fallback;

  return (
    <img
      src={`${process.env.PUBLIC_URL}/images/${src}`}
      alt={alt}
      // alt="" alone isn't enough for some screen readers on <img>; the
      // explicit presentation role keeps the decorative banners out of the
      // accessibility tree entirely. The hero passes a real alt and so gets
      // no role override.
      role={alt ? undefined : "presentation"}
      onError={() => setFailed(true)}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      draggable="false"
      className={className}
    />
  );
};

export default MarketingArt;
